import React, { useState, useEffect } from "react";
import {
  Divider,
  MemberCard,
  MemberInfo,
  MemberName,
  RowContainer,
  ScrollableContainer,
  TeamCard,
  TeamCardAvatar,
  Title,
  ShowMore,
  MemberLeftContent,
  ManagerIconContainer,
} from "./styles";
import { GetTeamMembersDetails } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../utils/methods";
import LazyImage from "../common/LazyImage/LazyImage";
import { ImageUrl } from "../../utils/constants";
import { ManagerRightArrowIcon } from "../../utils/icons";
import { useHistory } from "react-router-dom";

function TeamMembersCard() {
  const [teamMembersData, setTeamMembersData] = useState([]);
  const [showAllRows, setShowAllRows] = useState(false);
  const [totalTeamMember, setTotalTeamMember] = useState();

  const history = useHistory();

  const handleRedirect = (id) => {
    history.push(`/manager/people/${id}/personal-profile`);
  };

  useEffect(() => {
    fetchTeamMembersData();
  }, []);

  const fetchTeamMembersData = async () => {
    const apiUrl = `${GetTeamMembersDetails}`;

    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setTeamMembersData(res.data);
        setTotalTeamMember(res.data.length);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  const chunkArray = (array, size) =>
    array.reduce((acc, _, index) => {
      if (index % size === 0) acc.push(array.slice(index, index + size));
      return acc;
    }, []);

  const rows = chunkArray(teamMembersData, 4);

  if (teamMembersData.length === 0) {
    return null;
  }

  return (
    <TeamCard id="team-card">
      <Title id="team-title-count">Team Members ({totalTeamMember})</Title>
      <Divider></Divider>
      <ScrollableContainer
        id="scrollable-card"
        height="300px"
        showAllRows={showAllRows} /*style={{ minHeight: '300px' }}*/
      >
        {rows.map((row, rowIndex) => (
          <React.Fragment key={rowIndex} id="team-member-card">
            <RowContainer  id="row-container" key={`row-${rowIndex}`}>
              {row.map((member) => (
                <MemberCard
                  id="member-card"
                  key={member.id}
                  isBackground={member.bg_color}
                  onClick={() => handleRedirect(member.uid)}
                >
                  <MemberLeftContent id="member-content">
                    <TeamCardAvatar id="team-avatar">
                      <LazyImage
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "48px",
                        }}
                        onError={() =>
                          window.console.error("Image failed to load")
                        }
                        src={`${ImageUrl}/${member.profile_image}`}
                      />
                    </TeamCardAvatar>
                    <MemberInfo id="member-info">
                      <MemberName>{member.full_name}</MemberName>
                    </MemberInfo>
                  </MemberLeftContent>
                  <ManagerIconContainer
                    id="right-arrow-icon"
                    isWidth={"16px"}
                    isHeight={"16px"}
                    style={{ marginRight: "4px" }}
                  >
                    {ManagerRightArrowIcon()}
                  </ManagerIconContainer>
                </MemberCard>
              ))}
            </RowContainer>
            <Divider isMargin={"8px 0px"} />
            {rowIndex === 2 && teamMembersData.length > 12 && !showAllRows && (
              <ShowMore  id="show-more-button" onClick={() => setShowAllRows(true)} height="64px">
                Show More
              </ShowMore>
            )}
          </React.Fragment>
        ))}
        {/* {teamMembersData.length > 12 && !showAllRows && (
          <ShowMore
            onClick={() => setShowAllRows(true)}
            style={{
              cursor: "pointer",
              marginTop: "10px",
              textAlign: "center",
              color: "#184A61",
            }}
          >
            Show More
          </ShowMore>
        )} */}
      </ScrollableContainer>
    </TeamCard>
  );
}

export default TeamMembersCard;
